export default __webpack_public_path__ + "static/media/icon1-1.223178eb.png";